import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';


const styles = {
    nowrapCell: {
        whiteSpace: 'nowrap'
    }
};


class AffectationsIndicateursTable extends React.Component {

    render() {
        const { affectations, classes } = this.props;

        return (
            <TableContainer sx={{ maxHeight: 700 }}>
                <Table stickyHeader >
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.nowrapCell}>Groupe de traitement</TableCell>
                            <TableCell className={classes.nowrapCell}>Utilisateur affecté</TableCell>
                            <TableCell>{`Nombre\xa0de\xa0dossiers après-vente non\xa0affectés, à\xa0la\xa0date\xa0de\xa0fin\xa0(${affectations.nombreNonAffecteesTotal})`}</TableCell>
                            <TableCell>{`Nombre\xa0de\xa0dossiers après-vente en\xa0cours, à\xa0la\xa0date\xa0de\xa0fin\xa0(${affectations.nombreEnCoursTotal})`}</TableCell>
                            <TableCell>{`Nombre\xa0de\xa0dossiers après-vente affectés sur\xa0l'intervalle\xa0(${affectations.nombreAffecteesTotal})`}</TableCell>
                            <TableCell>{`Nombre\xa0de\xa0dossiers après-vente clôturés sur\xa0l'intervalle\xa0(${affectations.nombreClotureesTotal})`}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {affectations.groupes.map((groupe, indexGroupe) => ([
                            <TableRow key={indexGroupe * 1000} hover>
                                <TableCell className={classes.nowrapCell}>{groupe.libelle}</TableCell>
                                <TableCell />
                                <TableCell align="right">{groupe.nombreNonAffectees}</TableCell>
                                <TableCell align="right">{groupe.nombreEnCoursTotal}</TableCell>
                                <TableCell align="right">{groupe.nombreAffecteesTotal}</TableCell>
                                <TableCell align="right">{groupe.nombreClotureesTotal}</TableCell>
                            </TableRow>,
                            groupe.affectations.map((affectation, indexAffectation) => (
                                <TableRow key={indexGroupe * 1000 + indexAffectation} hover>
                                    <TableCell className={classes.nowrapCell}>{groupe.libelle}</TableCell>
                                    <TableCell className={classes.nowrapCell}>{affectation.utilisateur}</TableCell>
                                    <TableCell />
                                    <TableCell align="right">{affectation.nombreEnCours}</TableCell>
                                    <TableCell align="right">{affectation.nombreAffectees}</TableCell>
                                    <TableCell align="right">{affectation.nombreCloturees}</TableCell>
                                </TableRow>
                            ))]
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        );
    }
}

AffectationsIndicateursTable.propTypes = {
    classes: PropTypes.object.isRequired,
    affectations: PropTypes.object.isRequired
};

export default withStyles(styles)(AffectationsIndicateursTable);